const getFileExtension = (fileName: string) => {
	const lastDot = fileName.lastIndexOf(".");
	return lastDot === -1 ? "" : fileName.slice(lastDot + 1).toLowerCase();
};

export const getDisallowedFiles = (
	uploadFiles: ReadonlyArray<File>,
	allowedExtensions: ReadonlyArray<string>,
): File[] => {
	const allowed = new Set(allowedExtensions.map((extension) => extension.toLowerCase()));
	return uploadFiles.filter((file) => !allowed.has(getFileExtension(file.name)));
};

export const getAcceptAttribute = (allowedExtensions: ReadonlyArray<string>) =>
	allowedExtensions.map((extension) => `.${extension}`).join(",");
